import { XandrData } from '../../shared/types/ast';
import { requestBanners } from '../utils/banners';
import { loadTagsWithPrebid } from '../utils/relevant-digital-load-ads';

export function copyQueue() {
    const { queue } = window.FINN.banner;
    const tempQueue = Array.isArray(queue) ? [...queue] : [];

    if (window.apntag) {
        window.FINN.banner.queue = window.apntag.anq;
        const { anq } = window.apntag;
        tempQueue.forEach((element) => anq.push(element));
    }
}

export function mockPodlet(xandrData: XandrData) {
    const { apntag } = window;
    if (apntag) {
        apntag.debug = true;
        window.FINN = window.FINN || ({} as any);
        window.FINN.banner = window.FINN.banner || ({} as any);
        window.FINN.banner.debouncedLoadTags = () => loadTagsWithPrebid(apntag);
        requestBanners(apntag, xandrData, false, true);
        copyQueue();
    }
}
